import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actionCreators from '../../actions/sample-hardening';
import {default as Config} from '../../config'
import { Link } from '../../components/router/link';
import moment from 'moment';

export class TopMonths extends React.Component {

  renderMonths()
  {
      let months = ['Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec', 'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień'],
          html = []

      for(let i = 1; i <= 12; i++){
        html.push(
          <Link pathname="sample_hardening" query={{month: (i < 9 ? '0'+i : i), year: '2018'}}>
            <a className={"ui button "+(i == this.props.active ? 'green' : '')}>{ months[i-1] }</a>
          </Link>)
      }

      return html
  }

	render () {
    return(
      <div>
        { this.renderMonths() }
      </div>
    );
	}
}



/** WEBPACK FOOTER **
 ** ./js/views/sample_hardening/TopMonths.js
 **/